/* CANFOTO / GDX — ETAP 2
   M6A R0 — AUTO-MATERIALIZATION V2 CACHE SHADOW CONSUMER
   DATA-ONLY / NO VISIBLE DOM / NO SCORE-RANK-FP-SETUP MUTATION.

   Reads the server-rendered Shopify product metafield projection:
   canfoto_nora.materialized_profile_v2

   R0 is SHADOW_ONLY. It must never replace the current frozen PDP owner.
*/
(()=>{
'use strict';
const VERSION='CANFOTO-ETAP2-M6A-R0-AUTO-MATERIALIZATION-V2-CACHE-SHADOW-V1';
const SCHEMA='CANFOTO_NORA_PRODUCT_PROFILE_V2';
const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
const clone=v=>{try{return structuredClone(v)}catch(_){return JSON.parse(JSON.stringify(v))}};
const deepFreeze=v=>{
  if(!v||typeof v!=='object'||Object.isFrozen(v)) return v;
  Object.keys(v).forEach(k=>deepFreeze(v[k]));
  return Object.freeze(v);
};
function parseContext(){
  const el=document.getElementById('canfotoNoraMaterializedCacheV2Context');
  if(!el) return null;
  try{return JSON.parse(el.textContent||'{}')}catch(error){return {__parseError:clean(error?.message||error)}};
}
function parseProfile(raw){
  if(raw==null||raw==='') return null;
  if(typeof raw==='string'){
    const s=raw.trim();
    if(!s) return null;
    try{return JSON.parse(s)}catch(_){return null}
  }
  return raw&&typeof raw==='object'?raw:null;
}
function hex64(v){return /^[0-9a-f]{64}$/i.test(clean(v))}
function uniqueSetupIds(rows){
  const ids=(rows||[]).map(x=>clean(x?.setupRecordId||x?.canonicalSetupRecordId)).filter(Boolean);
  return ids.length===5&&new Set(ids).size===5;
}
const context=parseContext();
const rawProfile=parseProfile(context?.profile);
const handle=clean(context?.productHandle);
const productId=clean(context?.productId);
const state={
  version:VERSION,
  schema:SCHEMA,
  mode:'SHADOW_ONLY',
  status:'BOOTING',
  ready:false,
  cachePresent:!!rawProfile,
  productHandle:handle,
  productId,
  profile:null,
  profileFingerprint:'',
  decisionFingerprint:'',
  setupFingerprint:'',
  contentFingerprint:'',
  checks:{},
  failedChecks:[],
  guards:{
    visibleDomMutation:'NONE',
    scoreMutation:'NONE',
    rankingMutation:'NONE',
    fpMutation:'NONE',
    setupTruthMutation:'NONE',
    commerceMutation:'NONE',
    shareMutation:'NONE',
    currentFrozenOwnerMutation:'NONE'
  }
};
function finish(){
  const checks=state.checks;
  state.failedChecks=Object.entries(checks).filter(([,v])=>v!==true).map(([k])=>k);
  state.ready=state.failedChecks.length===0;
  if(!rawProfile){
    state.status='EMPTY_NO_PROFILE';
    state.ready=true;
    state.failedChecks=[];
  }else{
    state.status=state.ready?'READY_SHADOW':'HOLD_INVALID_PROFILE';
  }
  const api=deepFreeze({
    version:VERSION,
    schema:SCHEMA,
    mode:'SHADOW_ONLY',
    getState:()=>deepFreeze(clone(state)),
    getProfile:()=>rawProfile?deepFreeze(clone(rawProfile)):null,
    hasReadyProfile:()=>state.status==='READY_SHADOW'
  });
  window.CANFOTO_NORA_MATERIALIZED_CACHE_V2=api;
  window.dispatchEvent(new CustomEvent('canfoto:m6a-r0-cache-shadow-ready',{detail:{version:VERSION,status:state.status,productHandle:handle}}));
}
if(!context){
  state.status='HOLD_CONTEXT_MISSING';
  state.checks={contextPresent:false};
  finish();
  return;
}
if(context.__parseError){
  state.status='HOLD_CONTEXT_PARSE';
  state.checks={contextPresent:true,contextParse:true};
  finish();
  return;
}
if(!rawProfile){
  state.checks={contextPresent:true,productHandlePresent:!!handle,productIdPresent:!!productId,shadowOnly:true};
  finish();
  return;
}
const top5=Array.isArray(rawProfile?.setupProjection?.top5)?rawProfile.setupProjection.top5:[];
const profileHandle=clean(rawProfile?.product?.handle);
const profileId=clean(rawProfile?.product?.id);
state.profileFingerprint=clean(rawProfile?.cache?.profileFingerprint);
state.decisionFingerprint=clean(rawProfile?.source?.decisionFingerprint);
state.setupFingerprint=clean(rawProfile?.source?.setupFingerprint);
state.contentFingerprint=clean(rawProfile?.source?.contentFingerprint);
state.checks={
  contextPresent:true,
  productHandlePresent:!!handle,
  productIdPresent:!!productId,
  schemaExact:clean(rawProfile?.schema)===SCHEMA,
  schemaVersionExact:clean(rawProfile?.schemaVersion)==='2.0.0',
  statusReady:clean(rawProfile?.status)==='READY',
  activationActive:clean(rawProfile?.cache?.activationState)==='ACTIVE',
  productHandleExact:profileHandle===handle,
  productIdExact:!profileId||profileId===productId,
  engineSupported:['GDX_PANEL_LED_V4','GDX_COB_LED_V5'].includes(clean(rawProfile?.admission?.engineOwner)),
  noraReady:rawProfile?.admission?.noraReady===true,
  top5ExactlyFive:top5.length===5,
  top5UniqueSetupIds:uniqueSetupIds(top5),
  top5RankSequential:top5.every((x,i)=>Number(x?.rank)===i+1),
  everySetupProductContextExact:top5.every(x=>!clean(x?.productHandle)||clean(x?.productHandle)===handle),
  sourceInputFingerprint:hex64(rawProfile?.source?.inputFingerprint),
  profileFingerprint:hex64(rawProfile?.cache?.profileFingerprint),
  shadowOnly:clean(context?.mode)==='SHADOW_ONLY'
};
state.profile=rawProfile;
finish();
})();
